import LoginComponent from "./LoginComponent";
interface LoginModalProps {
    isOpen: boolean;
    onClose: () => void;
    redirectPath?: string;
    title?: string;
}

export default function LoginModal({
    isOpen,
    onClose,
    redirectPath = "/",
    title = "Sign In or Create an Account"
}: LoginModalProps) {
    if (!isOpen) return null;

    return (
        <LoginComponent
            isOpen={isOpen}
            onClose={onClose}
            onSuccess={onClose}
            redirectPath={redirectPath}
            title={title}
        />
    );
}
